import React from 'react'
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    InputNumber,
    DatePicker,
    Switch
} from 'antd'
import moment from 'moment';
import API from '../../../services/API'

const { Option } = Select

class RegistrationForm extends React.Component {
    // eslint-disable-next-line react/state-in-constructor
    state = {
        // eslint-disable-next-line react/no-unused-state
        confirmDirty: false,
        // eslint-disable-next-line react/no-unused-state
        autoCompleteResult: [],
        // eslint-disable-next-line react/no-unused-state
        customer_types: [],
        // eslint-disable-next-line react/no-unused-state
        subsidiaries: [],
    }

    componentDidMount() {
        // this.fillTestData();
        this.getCustomerTypes();
        this.getSubsidiaries();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.last_sync && prevProps.last_sync !== this.props.last_sync) {
            console.log('some')

            const { setFieldsValue } = this.props.form
            // eslint-disable-next-line prefer-const
            let refreshForm = {}

            if (this.props.name !== '') {
                refreshForm.name = this.props.name;
            }

            if (this.props.description !== '') {
                refreshForm.description = this.props.description;
            }

            if (this.props.priority !== '') {
                refreshForm.priority = this.props.priority;
            }

            if (this.props.type !== '' && this.props.type !== undefined && this.props.type !== null) {
                // data.type llega como objeto { value } (convención de campos de Ant),
                // hay que desenvolverlo: setFieldsValue espera el valor plano del Select,
                // no el objeto, o Ant intenta recorrerlo como si fueran sub-campos anidados.
                refreshForm.type = (typeof this.props.type === 'object' && 'value' in this.props.type)
                    ? this.props.type.value
                    : this.props.type;
            }

            if (this.props.date_from && moment(this.props.date_from)) {
                refreshForm.date_from = moment(this.props.date_from);
            }

            if (this.props.date_to && moment(this.props.date_to)) {
                refreshForm.date_to = moment(this.props.date_to);
            }
            if (this.props.active !== undefined && this.props.active !== null && this.props.active !== '') {
                // Chequeo explícito (no truthy): active === false es un valor válido
                // (descuento desactivado) y también debe reflejarse en el switch.
                refreshForm.active = this.props.active;
            }
            if (this.props.customer_types !== '') {
                // refreshForm.customer_type_id = this.props.customer_types.map((g) => ({ key: g.id, label: g.name }));
                refreshForm.customer_type_id = this.props.customer_types.map((g) => g.id);
            }

            if (this.props.subsidiaries !== '') {
                // refreshForm.subsidiarie_id = this.props.subsidiaries.map((g) => ({ key: g.id, label: g.name }));
                refreshForm.subsidiarie_id = this.props.subsidiaries.map((g) => g.id);
            }

            if (Object.keys(refreshForm).length !== 0) {
                // eslint-disable-next-line react/no-did-update-set-state
                setFieldsValue({ ...refreshForm });
            }

            // eslint-disable-next-line prefer-const
            let refreshData = {}
            if (this.props.subsidiaries && this.props.subsidiaries.length !== 0) {
                refreshData.subsidiaries = this.props.subsidiaries;
            }
            if (this.props.customer_types && this.props.customer_types.length !== 0) {
                refreshData.customer_types = this.props.customer_types;
            }
            if (Object.keys(refreshData).length !== 0) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ ...refreshData });
            }
            this.getSubsidiaries();
            this.getCustomerTypes();
        }
    }

    getSubsidiaries = () => {
        API.get('/api/subsidiaries?pagination=false&filter[active]=true')
            .then((response) => {
                this.setState({
                    // eslint-disable-next-line react/no-unused-state
                    subsidiaries: response.data,
                });
            })
            .catch((err) => {
                console.error('Este es el response: ', error);
            });
    }

    getCustomerTypes = () => {
        API.get('/api/customer_types?pagination=false&filter[active]=true')
            .then((response) => {
                console.log('soy')
                this.setState({
                    // eslint-disable-next-line react/no-unused-state
                    customer_types: response.data,
                });
            })
            .catch((err) => {
            });
    }

    fillTestData = () => {
        if (this.props.form) {
            this.props.form.setFieldsValue({
                name: 'name',
                description: 'description',
                priority: 1,
                type: 'item_based',
                item_based: {
                    sell_type: 'each',
                },
            });
        }
    }
    disabledStartDate = (current) => {
        // Disable dates before today
        return current && current < moment().startOf('day');
      };

      disabledEndDate = (current) => {
        const { getFieldValue } = this.props.form;
        const startDate = getFieldValue('date_from'); // Get the selected start date

        // Disable dates before today and before the selected start date
        return (current && current < moment().startOf('day')) || (startDate && current < startDate);
      };
    handleSubmit = (e) => {
        e.preventDefault()
        // eslint-disable-next-line no-unused-vars
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                // aqui se debe ejecutar funcion de que se hizo todo bien
                // eslint-disable-next-line no-unused-expressions
                this.props.onCompleted && this.props.onCompleted()
            }
        })
    }

    render() {
        // const { getFieldDecorator } = this.props.form
        const { getFieldDecorator, getFieldError, isFieldTouched, setFieldsValue } = this.props.form
        // console.log('this props',this.props);
        // console.log(this.props.active && this.props.active.value !== undefined?this.props.active.value:'ok');
        return (
            <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={{ span: 12, offset: 6 }}>
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item label="Nombre Descuento">
                            {getFieldDecorator('name', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Debes escribir un nombre',
                                    },
                                ],
                            })(<Input disabled={this.props.isLoading} />)}
                        </Form.Item>
                        <Form.Item label="Descripción">{getFieldDecorator('description')(<Input disabled={this.props.isLoading} />)}</Form.Item>
                        <Form.Item label="Prioridad" style={{ display: 'none' }}>
                            {getFieldDecorator('priority', {
                                initialValue: 1,
                                rules: [
                                    {
                                        required: true,
                                        message: 'Debes escribir un número de prioridad',
                                    },
                                ],
                            })(<InputNumber min={1} max={100} disabled={this.props.isLoading} />)}
                        </Form.Item>
                        <Form.Item label="Tipo de descuento" style={{ display: 'none' }}>
                            {getFieldDecorator('type', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Selecciona un tipo de descuento',
                                    },
                                ],
                            })(
                                <Select
                                    disabled={this.props.isLoading}
                                    placeholder="Seleccione un tipo"
                                >
                                    <Option value="quantity_based">Por cantidad</Option>
                                    {/* <Option value="item_based">Condicional</Option> */}
                                </Select>,
                            )}
                        </Form.Item>

                        <Form.Item label="Tipo cliente">
                            {getFieldDecorator('customer_type_id', {
                                initialValue: [1],
                                rules: [
                                    {
                                        required: true,
                                        message: 'Selecciona un tipo de precio',
                                    },
                                ],
                            })(
                                // eslint-disable-next-line react/self-closing-comp
                                <Select
                                    placeholder="Seleccione un tipo de precio"
                                    mode="multiple"
                                    optionLabelProp="label"
                                    search
                                    optionFilterProp="label"
                                    disabled
                                >
                                    {this.state.customer_types.map((g) => (
                                        <Option label={g.name} key={g.id} value={g.id}>{g.name}</Option>
                                    ))}
                                </Select>,
                            )}
                        </Form.Item>

                        <Form.Item label="Sucursales">
                            {getFieldDecorator('subsidiarie_id', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Selecciona una sucursal',
                                    },
                                ],
                            })(
                                // eslint-disable-next-line react/self-closing-comp
                                <Select
                                    placeholder="Seleccione una sucursal"
                                    mode="multiple"
                                    search
                                    optionLabelProp="label"
                                    optionFilterProp="label"
                                    disabled={this.props.isLoading}
                                >
                                    {this.state.subsidiaries.map((g) => (
                                        <Option label={g.name} key={g.id} value={g.id}>{g.name}</Option>
                                    ))}
                                </Select>,
                            )}
                        </Form.Item>
                        <Row gutter={24}>
                            <Col lg={8} md={12} sm={24}>
                                <Form.Item label="Fecha inicio">
                                    {getFieldDecorator('date_from', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Selecciona al menos la fecha actual',
                                            },
                                        ],
                                    })(
                                        <DatePicker
                                            format="YYYY-MM-DD"
                                            placeholder="Fecha inicio"
                                            disabled={this.props.isLoading}
                                            disabledDate={this.disabledStartDate}
                                            />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col lg={8} md={12} sm={24}>
                                <Form.Item label="Fecha fin">
                                    {getFieldDecorator('date_to', {
                                        rules: [
                                            {
                                                required: false,
                                                message: '',
                                            },
                                        ],
                                    })(
                                        <DatePicker
                                            format="YYYY-MM-DD"
                                            placeholder="Fecha fin"
                                            disabled={this.props.isLoading}
                                            disabledDate={this.disabledEndDate}
                                            />,
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item label="Activo">
                                            {getFieldDecorator('active', {
                                                initialValue: true,
                                                valuePropName: 'checked',
                                                rules: [],
                                            })(<Switch></Switch>)}
                                        </Form.Item>

                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button
                                style={{ marginRight: 8 }}
                                disabled={this.props.isLoading}
                                onClick={() => this.props.history.push('/discounts')}
                            >
                                Regresar al listado
                            </Button>
                            <Button type="primary" htmlType="submit" disabled={this.props.isLoading} loading={this.props.isLoading}>
                                Siguiente
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        )
    }
}

const WrappedRegistrationForm = Form.create({
    name: 'DiscountsRegistrationForm',
    onFieldsChange(props, changedFields) {
        props.onFieldChange(changedFields)
    },
    mapPropsToFields(props) {
        return {
            name: Form.createFormField({
                ...props.name,
            }),
            description: Form.createFormField({
                ...props.description,
            }),
            priority: Form.createFormField({
                ...props.priority,
            }),
            type: Form.createFormField({
                ...props.type,
            }),
            date_from: Form.createFormField({
                ...props.date_from,
            }),
            date_to: Form.createFormField({
                ...props.date_to,
            }),
            customer_type_id: Form.createFormField({
                ...props.customer_type_id,
            }),
            subsidiarie_id: Form.createFormField({
                ...props.subsidiarie_id,
            }),
            active: Form.createFormField({
                ...props.active,
            }),
        }
    },
})(RegistrationForm)

export default WrappedRegistrationForm
